import { Check } from "lucide-react";
import { money } from "@/lib/currency";
import { useT } from "@/lib/i18n";

export const OptionRow = ({ option, on, radio, accent, cur, priceLabel, onClick }) => {
  const { t } = useT();
  const off = option.available === false;
  return (
    <button type="button" disabled={off} data-testid={`${radio ? "variant" : "addon"}-option-${option.id}`} onClick={onClick}
      className={`w-full flex items-center gap-3 bg-white border rounded-xl px-3.5 py-3 text-left transition-colors ${off ? "opacity-50" : ""}`}
      style={{ borderColor: on ? accent : "#E6E1DA" }}>
      <span className={`h-5 w-5 border grid place-items-center shrink-0 ${radio ? "rounded-full" : "rounded-md"}`} style={on ? { backgroundColor: accent, borderColor: accent } : { borderColor: "#CFC8BE" }}>
        {on && (radio ? <span className="h-2 w-2 rounded-full bg-white" /> : <Check className="h-3.5 w-3.5 text-white" />)}
      </span>
      <span className="flex-1 text-sm text-[#1F1D1B]">{option.name}</span>
      {off ? <span className="text-[10px] font-semibold uppercase text-red-600">{t("soldOut")}</span> : priceLabel != null && <span className="text-sm font-mono-j text-[#6B6560]">{priceLabel}</span>}
    </button>
  );
};

export const optionPrice = (price, isBase, cur) => (isBase ? money(price, cur) : price ? `+${money(price, cur)}` : null);
